import React, { Component } from "react";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import PropTypes from "prop-types";
import AppBarModal from "../../general/AppBarModal";
import { consulta, obtenerValoresFiltros } from "../../../global/js/funciones";
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from "../../../global/imagenes/emma_w.png";
import ListarDatos from "../../general/ListarDatos";
import { BtnCancelar, BtnForm, BtnSeleccion } from "../../general/BotonesAccion";
import { AREAS_INTERES } from "../helper";
 
class BuscarAreasInteres extends Component {
    state = { cargando: false, areas: [] };
    
    async componentDidUpdate(prevProps) {
        const { modalBuscarArea } = this.props;
        if (modalBuscarArea && modalBuscarArea !== prevProps.modalBuscarArea) {
        this.setState({ cargando: true });
        try {
            const { genericKey } = this.props;
            const areas = await obtenerValoresFiltros([
            { llave: "generica", valor: genericKey },
            ]);
            this.setState({ areas: areas || [], cargando: false });
        } catch (e) {
            console.error(e);
            this.setState({ areas: [], cargando: false });
        }
        }
    }
    
    filtrarVacantes = () => {
        const idsAreas = (this.props.seleccionadas || []).map(a => a.id);
        this.setState({ cargando: true });
        consulta("api/v1.0/portal/filtrar_por_area", { areas: idsAreas }, "post", (error, estado, resp) => {
        setTimeout(() => {
        if (estado === 200) {
            if (typeof this.props.onFiltrar === "function") {
                this.props.onFiltrar(resp); 
                this.setState({ cargando: false });
                this.props.mostrarModalBuscarArea(false);
            }
            this.props.mostrarModalBuscarArea(false); 
        } else {
            alert(resp?.titulo || "Error al filtrar vacantes");
        }
        this.setState({ cargando: false });
        },200);
        });
    };

    acciones = (row) => {
        const {
        seleccionadas = [],
        seleccionar,
        quitar,
        mostrarModalAddPosicion,
        } = this.props;
    
        const yaSeleccionado = (seleccionadas || [])
        .map((a) => a.id)
        .includes(row.id);
    
        const onSeleccionar = () => {
        if (typeof mostrarModalAddPosicion === "function") {
            mostrarModalAddPosicion(true);
        }
        if (typeof seleccionar === "function") {
            seleccionar(row);
        }
        };
    
        const onQuitar = () => {
        if (typeof quitar === "function") {
            quitar(row);
        }
        };
    
        return yaSeleccionado ? (
        <BtnCancelar callback={onQuitar} />
        ) : (
        <BtnSeleccion callback={onSeleccionar} />
        );
    };

  
 
    render() {
        const { cargando, areas } = this.state;
        const { modalBuscarArea, mostrarModalBuscarArea, titulo } = this.props;
    
        return (
        <Dialog
            open={modalBuscarArea}
            onClose={mostrarModalBuscarArea.bind(this, false)}
            fullWidth
            maxWidth="sm"
        >
            <AppBarModal
            titulo={titulo}
            mostrarModal={mostrarModalBuscarArea}
            titulo_accion=""
            accion=""
            />
            <DialogContent className="scroll" style={{ padding: 0 }}>
            {cargando ? (
                <TareasTerminadas
                mensaje="Cargando.."
                marginTop="7%"
                imagen={emma_w}
                widthImg="7%"
                />
            ) : (
                <ListarDatos
                datos={areas}
                titulo="Lista de Áreas de Interés"
                opciones
                buscar
                sub_titulo="Áreas"
                id="tbl_areas_seleccion"
                acciones={(row) => this.acciones(row)}
                fila_principal="nombre"
                filas={[]}
                />
            )}
            </DialogContent>
            <DialogActions>
            <BtnForm
                texto="FILTRAR"
                callback={this.filtrarVacantes}
            />
            </DialogActions>
        </Dialog>
        );
    }
    }
    
    BuscarAreasInteres.propTypes = {
    modalBuscarArea: PropTypes.bool.isRequired,
    mostrarModalBuscarArea: PropTypes.func.isRequired,
    seleccionar: PropTypes.func.isRequired,
    quitar: PropTypes.func.isRequired,
    seleccionadas: PropTypes.array,
    genericKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    titulo: PropTypes.string,
    mostrarModalAddPosicion: PropTypes.func,
    };
    
    BuscarAreasInteres.defaultProps = {
    seleccionadas: [],
    genericKey: AREAS_INTERES,
    titulo: "¡ Lista de Áreas de Interés !",
    };
    
export default BuscarAreasInteres;
